import React from 'react';
import { Col, Card } from 'react-bootstrap';
import { SearchInput } from '../../widgets';

const Header = (props) => {
    return <Card.Header className="q-app-header d-flex">
        <Col lg={5} md={5} sm={5} className="title">Q-app (Now)</Col>
        <Col lg={7} md={7} sm={7} className="search-input"><SearchInput onChange={searchText => props.setSearchText(searchText)} /></Col>
    </Card.Header>
}

export default Header;